var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"pa-0":"","fluid":""}},[_c('Introduction',{attrs:{"displayBanner":true}}),_c('MarketingPoints'),_c('LessonContents'),_c('UserInterviews'),_c('PriceOverview'),_c('FunctionList'),_c('MediaCoverage'),_c('FAQSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }